import { useAnticipationStatus } from "@/hooks/useAnticipationStatus.ts";
import { getColorBadgeStatus, getStatus } from "@/utils";
import { Button, Pills } from "barte-design-system";
import { useMemo } from "react";

interface ChangeToPaidProps {
  status: string;
  setShowAlert: (param: boolean) => void;
}

const MANUALLY_PAID_STATUS = "PAID_MANUALLY";

export const changeToPaidAlertTitle = "Confirme a alteração do status";

function StatusPill({ status }: { status: string }) {
  return (
    <span style={{ display: "inline-flex", verticalAlign: "middle" }}>
      <Pills
        label={getStatus(status)}
        variant="light"
        state={getColorBadgeStatus(status)}
        size="sm"
      />
    </span>
  );
}

export function ChangeToPaidAlertMessage({ status }: { status: string }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        color: "var(--content-secondary)",
      }}
    >
      <p>
        Você está alterando o status dessa cobrança de{" "}
        <StatusPill status={status} /> para{" "}
        <StatusPill status={MANUALLY_PAID_STATUS} />.
      </p>
      <p>Essa alteração não poderá ser desfeita.</p>
    </div>
  );
}

const BLOCKED_STATUSES = new Set([
  "PAID",
  "PAID_MANUALLY",
  "REFUND",
  "CANCELED",
] as const);

function canShowMarkAsPaid(status: string, hasAntecipationActive: boolean) {
  if (!status) return false;
  if (BLOCKED_STATUSES.has(status as any)) return false;
  if (hasAntecipationActive) return false;
  return true;
}

export function ChangeToPaid({ status, setShowAlert }: ChangeToPaidProps) {
  const { hasAntecipationActive } = useAnticipationStatus();
  const showMarkPaid = useMemo(
    () => canShowMarkAsPaid(status, hasAntecipationActive),
    [status, hasAntecipationActive]
  );

  if (!showMarkPaid) return null;

  return (
    <Button
      id="alterar_pago"
      variant="link"
      size="sm"
      onClick={() => setShowAlert(true)}
    >
      Marcar como paga
    </Button>
  );
}
